/*
 * @Author: crazycattle
 * @Date: 2021-05-31 17:42:11
 * @Description: content
 */
import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn" //接口API
const url = {
    getNodonums:root+"/Stutask/getNodonums",//个人中心 获取全部孩子信息
    getOneStudent:root+"/Student/getOneStudent",//个人中心->获取单个孩子信息--zjb
}
const indexApi =  {
  getNodonums(params){
    return axios.get(url.getNodonums,{ params })
  },
  getOneStudent(params){
    return axios.get(url.getOneStudent,{ params })
  },
}

export default indexApi;